module.exports = __webpack_public_path__ + "img/collection-weddingRingsDiamonds.122ba87.jpg";